var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderTop',{on:{"reload":_vm.reload}}),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('FooterBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }